import * as React from 'react';
import { Card } from 'react-bootstrap';

interface Props {
  title: string;
  body: string;
}

export const WebsiteStaticPage = ({ title, body }: Props): React.JSX.Element => (
  <Card>
    <Card.Body>
      <Card.Title>{title}</Card.Title>
      <Card.Text>{body}</Card.Text>
    </Card.Body>
  </Card>
);
